import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["statusField", "dateField", "timeField"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSelectedAndTodayDate, userLocalTimezone } from 'utils/timezone';
import getBasicDate from 'utils/dates/getBasicDate';
import { DEFAULT_TIME } from 'utils/times/defaultTime';
import RadioButtonOption from 'components/RadioButtonOption';
import FormField from 'components/FormField';
import Stack from 'components/Stack';
import CompletionDateTimeCard from './CompletionDateTimeCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function checkIsValid(field) {
  return field.value !== null;
}
function CompletionStatusField(_ref) {
  var statusField = _ref.statusField,
    dateField = _ref.dateField,
    timeField = _ref.timeField,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasCompletionDateTimeCard = statusField.value === 'completed' && checkIsValid(dateField) && checkIsValid(timeField);
  var timezone = userLocalTimezone;
  var _getSelectedAndTodayD = getSelectedAndTodayDate(dateField.value, timezone),
    selectedDate = _getSelectedAndTodayD.selectedDate,
    zonedTodayDate = _getSelectedAndTodayD.zonedTodayDate;
  var modes = [{
    label: 'actions_do_not_change',
    value: 'unchanged',
    onChange: function onChange() {
      return statusField.set('unchanged');
    }
  }, {
    label: 'actions_set_to_not_started',
    value: 'notstarted',
    onChange: function onChange() {
      statusField.set('notstarted');
      dateField.set(null);
      timeField.set(null);
    }
  }, {
    label: 'actions_set_to_completed',
    value: 'completed',
    onChange: function onChange() {
      var date = getBasicDate(zonedTodayDate);
      statusField.set('completed');
      dateField.set(date);
      timeField.set(DEFAULT_TIME);
    }
  }];
  var statusOptions = modes.map(function (mode) {
    return /*#__PURE__*/_jsx(RadioButtonOption, {
      id: mode.value,
      label: t(mode.label),
      checked: statusField.value === mode.value,
      value: mode.value,
      onChange: mode.onChange
    }, mode.value);
  });
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "fieldset",
    label: "".concat(t('property_new_completion_status'), " *")
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [statusOptions, hasCompletionDateTimeCard && /*#__PURE__*/_jsx(CompletionDateTimeCard, {
        dateField: dateField,
        timeField: timeField,
        selectedDate: selectedDate,
        timezone: timezone
      })]
    })
  }));
}
export default CompletionStatusField;